import React from 'react';

// Components
import Meta from '../components/meta.js';
import BlogListItem from '../components/blog-list-item.js';
import { BlogPosts } from './blog/blog-posts.js';
import { Link } from 'react-router-dom';
import { Subscribe } from '../v2/ui/components/subscribe';

const pageSize = 9;
const totalPages = Math.ceil(BlogPosts.length / pageSize);

const Blog = () => {
  const params = new URLSearchParams(window.location.search);
  const page = params.get('page') || '1';
  const start = (page - 1) * pageSize;
  const posts = BlogPosts.slice(start, start + pageSize);

  return (
    <div id="blog">
      <Meta
        title="Voltaware blog"
        description="Read the latest news on energy use trends and Voltaware insights"
        url="https://www.voltaware.com/blog"
      />

      <section className="section container wrapper">
        <div className="flex-wrap">
          {posts.map((post, i) => (
            <BlogListItem post={post} key={i} />
          ))}
        </div>
      </section>

      <section className="section container wrapper">
        <Subscribe />
      </section>

      <section className="section container wrapper">
        <nav className="blog-pages">
          {Array.from({ length: totalPages }, (_, i) => (
            <Link
              className={page === `${i + 1}` ? 'blog-page--active' : ''}
              key={i}
              to={`/blog?page=${i + 1}`}
            >
              {i + 1}
            </Link>
          ))}
        </nav>
      </section>
    </div>
  );
};

export default Blog;
